<template>
  <el-form ref="Multiselect" class="yk-multiselect" label-width="90px">
    <el-row>
      <el-col :span="22" :offset="1">
        <el-form-item label="题目：">
            <div v-if="IsTitle">
              <Editor placeholder="请输入内容" />
            </div>
            <div v-else>
               <span class="yk-multiselect-question" v-html="data.Content"></span>
            </div>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row v-if="filesList.length > 0">
      <el-col :span="22" :offset="1">
        <el-form-item label="题目附件：">
            <div v-if="IsTitle">
              <QuestionFile ref="fileList" :url="urlAliyunOSS" :fileIds.sync="fileIds" :filesList="filesList" :files.sync="fileList" :IsUpload="false"/>
            </div>
            <div v-else>
              <QuestionFile ref="fileList" :url="urlAliyunOSS" :fileIds.sync="fileIds" :filesList="filesList" :files.sync="fileList" :IsUpload="false"/>
            </div>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col v-if="IsSelects == 0" :span="15" :offset="1">
        <el-form-item label="选项：">
          <el-form-item label-width="30px" v-for="(question,index) in questions" :key="index">
            <el-checkbox-group v-model="check" >
              <el-checkbox :label="question.choice" @change="addCheckValue"></el-checkbox>
              <el-input placeholder="请输入选项内容"></el-input>
              <i class="el-icon-close" @click="closeChoice(index)"></i>
            </el-checkbox-group>
          </el-form-item>
        </el-form-item>
        <span @click="addChoice" class="yk-addChoice">
          <i class="el-icon-circle-plus"></i>
          添加选项
        </span>
      </el-col>
      <el-col v-else-if="IsSelects < 0" :span="15" :offset="1">
        <el-form-item label="选项：">
          <el-form-item  v-for="(question,index) in questions" :key="index">
              <span style="float:left">{{alphabet[index]}}.</span>
              <span v-html="question" class="yk-span-wrapper-s"></span>
          </el-form-item>
        </el-form-item>
      </el-col>
      <el-col v-else :span="15" :offset="1">
        <el-form-item label="选项：">
            <el-form-item  v-for="(question,index) in questions" :key="index">
                <el-radio v-model="stuAnswer[0]" :label="index" @change="doCheckValue" v-if="cont.QuestionType==1" style="float:left">&nbsp;{{alphabet[index]}}.</el-radio>
                <el-checkbox v-model="stuAnswer" :label="index" @change="doCheckValue" v-if="cont.QuestionType==2" style="float:left">{{alphabet[index]}}.</el-checkbox>
                <span v-html="question" class="yk-span-wrapper-s"></span>
            </el-form-item>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row v-show="IsAnswers">
      <el-col :span="22" :offset="1">
        <el-form-item label="答案：">
          <span v-for="(CheckValue,CheckValueIndex) in CheckValues" :key="CheckValue">{{alphabet[CheckValue]}}<span v-if="CheckValueIndex!=CheckValues.length-1">、</span></span>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row v-show="IsAnalysis != 0">
      <el-col :span="22" :offset="1">
        <el-form-item label="解析：">
            <Editor v-if="IsAnalysis > 0" placeholder="请输入内容" />
            <span v-else v-html="data.Analysis" class="yk-span-wrapper-s"></span>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row v-show="IsAnalysis != 0 && analysisFilesList.length > 0">
      <el-col :span="22" :offset="1">
        <el-form-item label="解析附件：">
            <QuestionFile ref="analysisFileList" :url="urlAliyunOSS" :fileIds.sync="analysisFileIds" :filesList="analysisFilesList" :files.sync="analysisFileList" :IsUpload="false"/>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
// import Vue from 'vue';
import QuestionFile from 'components/AliyunOSS/QuestionBankFile.vue';

export default {
  // name: 'multiselects',
  components: {
    QuestionFile
  },
  props: {
    IsTitle: {
      type: Boolean,
      default: true
    },
    IsSelects: {
      type: Number,
      default: 0
    },
    IsAnswers: {
      type: Boolean,
      default: true
    },
    IsAnalysis: {
      type: Number,
      default: 0
    },
    data: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  created() {
    this.cont = this.data;
    this.filesList = this.data.stemFiles;
    this.analysisFilesList = this.data.analysisFiles;
    let selectLength = this.cont.Selects.length;
    if(selectLength > 26){
      for(let i= 0;i < selectLength-26;i++){
        let indexStr = this.alphabet[parseInt(i/26)] +this.alphabet[i%26];
        this.alphabet.push(indexStr);
      }
    }
  },
  data() {
    return {
      urlAliyunOSS: '/api/design/osssign/getsign',
      // 题干附件
      fileList: [],
      fileIds: [], // 附件Id
      filesList: [],
      // 解析附件
      analysisFileList: [],
      analysisFileIds: [],
      analysisFilesList: [],
      cont: [],
      content: '请输入内容',
      formOption: {
        choice: null
      },
      questions: [
        {
          id: 0,
          choice: 'A',
          contrary: false
        },
        {
          id: 1,
          choice: 'B',
          contrary: false
        },
        {
          id: 2,
          choice: 'C',
          contrary: false
        },
        {
          id: 3,
          choice: 'D',
          contrary: false
        }
      ],
      CheckValues: [],
      check: [],
      radio: Number,
      alphabet: [
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y',
        'Z'
      ],
      stuAnswer: []
    };
  },
  watch: {
    'cont.ContentText': {
      handler: function() {
        this.questions = [];
        this.CheckValues = [];
        this.cont = this.data;
        this.data.Selects.forEach(element => {
          this.questions.push(element);
        });
        if (this.IsAnswers) {
          this.data.Answers.forEach(element => {
            this.CheckValues.push(element);
          });
        } else if (this.data.Answers) {
          this.stuAnswer = this.data.Answers.map((value) => {
            return parseInt(value);
          });
        }
        this.content = this.data.Analysis;
      },
      deep: true
    }
  },
  methods: {
    // 添加选项
    addChoice: function() {
      var n = this.questions.length;
      var str = { id: n, contrary: false, choice: this.alphabet[n] };
      this.questions.push(str);
      this.CheckValues.push(null);
    },
    // 删除选项
    closeChoice: function(index) {
      for (var i = 0; i <= index; i++) {
        this.questions[i].choice = this.alphabet[i];
      }
      this.questions.splice(index, 1);
      this.CheckValues = this.check;
    },
    // 添加正确答案
    addCheckValue: function() {
      this.CheckValues = this.check;
    },
    // 传递选择的答案
    doCheckValue: function() {
      this.$emit('getAnswer', {
        Id: this.cont.Id,
        Answers: this.stuAnswer.sort()
      });
    }
  }
};
</script>

<style lang="scss">

.yk-multiselect {
  .yk-multiselect-question{
    white-space: pre-wrap;
    p{
      margin:0;
      padding:0;
    }
  }
  .el-form-item .el-form-item {
    margin-bottom: 20px;
  }
  .el-input {
    width: 85%;
    margin-left: 15px;
  }
  i.el-icon-close {
    font-size: 15px;
    margin-left: 10px;
  }

  .el-col .yk-addChoice {
    margin-left: 70px;
    color: #606266;
  }
}
</style>

